import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { create, windowScheduler } from "@yornaath/batshit";
import { CloudForwarderForwarderInputStates } from "@graylog/enterprise-api";
const inputStateBatcher = create({
  fetcher: async (_keys) => {
    const stateMap = await CloudForwarderForwarderInputStates.all();
    return Object.values(stateMap).flat();
  },
  resolver: (items, key) => items.find((item) => `${item.forwarder_id}-${item.input_id}` === key),
  scheduler: windowScheduler(10)
});
const useForwarderInputState = (forwarderId, inputId) => {
  const compositeKey = `${forwarderId}-${inputId}`;
  const { data, isFetching, isPending } = useQuery({
    queryKey: ["forwarder", "input-states", compositeKey],
    queryFn: async () => {
      var _a;
      return (_a = await inputStateBatcher.fetch(compositeKey)) != null ? _a : null;
    },
    placeholderData: keepPreviousData,
    refetchInterval: 5e3,
    enabled: !!forwarderId
  });
  return { data, isFetching, isPending };
};
export default useForwarderInputState;
